export default "__VITE_ASSET__CfbsR7i4__"